import { Box, Typography } from "@mui/material";
import React from "react";
import { SchoolLeader } from "../../types/record";
import StarIcon from "../../assets/images/star.png";
import TimeIcon from "../../assets/images/hours.png";
import StudentsIcon from "../../assets/images/one-student.png";
import ActiveStudentsIcon from "../../assets/images/one-student-active.png";
import GoldIcon from "../../assets/images/gold-medal.png";
import SilverIcon from "../../assets/images/silver-medal.png";
import BronzeIcon from "../../assets/images/bronze-medal.png";
import { SPColor } from "../../constants/color";

type LeaderBoardProps = {
  item: SchoolLeader;
  type?: string;
};

export default function LeaderBoard({ item, type }: LeaderBoardProps) {
  const getRankNum = (rank: number) => {
    if (rank === 1) {
      return <img src={GoldIcon} width={35} alt="gold" />;
    }
    if (rank === 2) {
      return <img src={SilverIcon} width={35} alt="silver" />;
    }
    if (rank === 3) {
      return <img src={BronzeIcon} width={35} alt="bronze" />;
    }
    return rank;
  };

  const formattingSec = (seconds: number | undefined) => {
    if (!seconds) return "0";
    return seconds;
    // const hrs = Math.floor(seconds / 3600);
    // const mins = Math.floor((seconds % 3600) / 60);
    // const secs = seconds % 60;

    // if (hrs > 0) {
    //   return [hrs, mins, secs].map((v) => String(v).padStart(2, "0")).join(":");
    // }

    // return [mins, secs].map((v) => String(v).padStart(2, "0")).join(":");
  };

  return (
    <>
      <Box
        display="flex"
        marginTop={2}
        sx={{
          borderRadius: "5px",
          backgroundColor: SPColor.LIGHT_BLUE,
          height: "auto",
        }}
      >
        {/* time (desktop: none, mobile: block) and star */}
        <Box
          sx={{
            display: "flex",
          }}
        >
          <Box
            sx={{
              borderRadius: "5px",
              backgroundColor: SPColor.SYSTEM1,
              width: "140px",

              display: { sm: "flex", xs: "block" },
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Box
              sx={{
                display: "flex",
                py: 1,
                px: 2,
                borderRadius: "5px",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <img src={StarIcon} width="30" height="30" alt="star" />
              <Typography
                sx={{
                  ml: 1,
                  color: SPColor.WHITE,
                  fontSize: "1.3rem",
                }}
              >
                {item.stars}
              </Typography>
            </Box>

            <Box
              sx={{
                display: { sm: "none", xs: "flex" },
                py: 1,
                px: 2,
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <img src={TimeIcon} width="30" height="30" alt="star" />
              <Typography
                sx={{
                  ml: 2,
                  color: SPColor.WHITE,
                  fontSize: "1.1rem",
                }}
              >
                {formattingSec(item["speaking-hours"])}
              </Typography>
            </Box>
          </Box>
        </Box>

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            pl: 1,
            pr: 1,
            width: "100%",
            flexWrap: "wrap-reverse",

            flexDirection: { sm: "row", xs: "column-reverse" },
          }}
        >
          {/* active and total students */}
          <Box
            sx={{
              display: "flex",
              // height: "50px",
              flexWrap: "wrap",
            }}
          >
            <Box
              sx={{
                border: "solid 2px " + SPColor.SYSTEM1,
                borderRadius: "5px",
                margin: "5px",
                display: { sm: "flex", xs: "none" },
                alignItems: "center",
                justifyContent: "center",
                // px: 2,

                width: "100px",
              }}
            >
              <Typography
                sx={{
                  mr: 2,
                  color: SPColor.WHITE,
                }}
              >
                {formattingSec(item["speaking-hours"])}
              </Typography>
              <img src={TimeIcon} width="30" alt="students" />
            </Box>

            <Box
              sx={{
                border: "solid 2px " + SPColor.SYSTEM1,

                borderRadius: "5px",

                margin: "5px",

                display: "flex",

                alignItems: "center",

                justifyContent: "center",

                width: "100px",
              }}

              // borderRadius="5px"
            >
              <Typography
                sx={{
                  mr: 2,

                  color: SPColor.WHITE,
                }}

                // sx={{ display: { md: "block", xs: "none" } }}
              >
                {item["active-students"] || 0}
              </Typography>

              <img src={ActiveStudentsIcon} width="30" alt="students" />
            </Box>

            <Box
              sx={{
                border: "solid 2px " + SPColor.SYSTEM1,
                borderRadius: "5px",
                margin: "5px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                // px: 2,
                width: "100px",
              }}
            >
              <Typography
                sx={{
                  mr: 2,
                  color: SPColor.WHITE,
                }}
              >
                {item.students}
              </Typography>
              <img src={StudentsIcon} width="30" alt="students" />
            </Box>

            {type && type === "grade" && (
              <Box
                sx={{
                  ml: 2,
                  display: "flex",
                  alignItems: "center",
                  // justifyContent: "flex-end",
                }}
              >
                <Typography color={SPColor.WHITE}>{item.id}</Typography>
              </Box>
            )}
          </Box>

          <Box
            sx={{
              display: "flex",
              // height: "50px",
              justifyContent: "flex-end",
            }}
          >
            {/* name and ranking */}
            <Box
              sx={{
                display: "flex",
                paddingRight: "3px",
              }}
            >
              <Typography
                sx={{
                  color: SPColor.WHITE,
                  mr: 1,
                  fontSize: { md: "1.25rem", xs: "1rem" },
                  display: "flex",
                  alignItems: "center",
                  direction: "rtl",
                }}
                component="h6"
                variant="h6"
                textAlign="right"
              >
                {item.name}
              </Typography>
              <Typography
                sx={{
                  color: SPColor.WHITE,
                  display: "flex",
                  py: 0,
                  width: "30px",
                  justifyContent: "center",
                  alignItems: item.place < 4 ? "flex-start" : "center",
                }}
                component="h5"
                variant="h5"
              >
                {getRankNum(item.place)}
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
}
